import * as R from 'ramda';
import propIsTruthy from './propIsTruthy';

const propOrDash = R.curry((prop, data) => R.ifElse(propIsTruthy(prop), R.prop(prop), R.always('--'))(data));

export default propOrDash;
